module.exports = __webpack_public_path__ + "static/11-df0389a7eb3b1bfef0df258387555e08.jpg";